import React, { useState, useEffect, useCallback, useContext } from 'react';
import { Redirect } from 'react-router-dom';
import { Card, Container, Typography, Grid, Row, Col } from '@sm/wds-react';

import { CreateWizardConfigContext } from '../../CreateWizardConfigContext';

import { IconPoll, IconSurvey, IconTemplate } from '../../components/IconWrapper';

import './home.scss';

const Home = () => {
  const { createWizardConfig, setCreateWizardConfig } = useContext(CreateWizardConfigContext);
  const [shouldRedirect, setShouldRedirect] = useState(createWizardConfig.redirectToEditorPage);
  const [redirectUrl, setRedirectUrl] = useState('/createwizard/new-survey/poll');
  const [showCreatePollCard, setShowCreatePollCard] = useState(createWizardConfig.showCreatePollCard);
  const [showCreateSurveyCard, setShowCreateSurveyCard] = useState(createWizardConfig.showCreateSurveyCard);
  const [showStartFromTemplateCard, setShowStartFromTemplateCard] = useState(
    createWizardConfig.showStartFromTemplateCard
  );
  const [customStylings, setCustomStylings] = useState(createWizardConfig.style);

  useEffect(() => {
    setShouldRedirect(createWizardConfig.redirectToEditorPage);
    if (createWizardConfig.redirectToEditorPage) {
      if (createWizardConfig.redirectTo === 'templates') {
        setRedirectUrl(`/createwizard/${createWizardConfig.redirectTo}`);
      } else {
        setRedirectUrl(`/createwizard/new-survey/${createWizardConfig.redirectTo}`);
      }
    }
    setShowCreatePollCard(createWizardConfig.showCreatePollCard);
    setShowCreateSurveyCard(createWizardConfig.showCreateSurveyCard);
    setShowStartFromTemplateCard(createWizardConfig.showStartFromTemplateCard);
    setCustomStylings(createWizardConfig.style);
  }, [createWizardConfig]);

  const onMessageReceivedFromIframe = useCallback(
    event => {
      if (
        event.data &&
        event.data.message &&
        typeof event.data.message !== 'object' &&
        event.data.source === 'create-wizard-app'
      ) {
        const data = JSON.parse(event.data.message);
        setCreateWizardConfig(data);
      }
    },
    [setCreateWizardConfig]
  );

  useEffect(() => {
    window.addEventListener('message', onMessageReceivedFromIframe);
    return () => window.removeEventListener('message', onMessageReceivedFromIframe);
  }, [onMessageReceivedFromIframe]);

  const root = document.documentElement;

  root.style.setProperty('--customIconColor', customStylings.iconColor);

  return (
    <Container data-testid="Home" className="sm-home">
      <Grid noBleeds>
        <Row>
          <Col>
            <Container className="sm-home__page-title" mt={6} pl={4} pb={4}>
              <Typography variant="cardTitle">Get started</Typography>
            </Container>
            <Container flex className="sm-home__top-cards" mt={5} px={4}>
              <If condition={shouldRedirect}>
                <Redirect to={redirectUrl} />
              </If>
              <If condition={showCreatePollCard}>
                <Card
                  data-testid="Home__PollCard"
                  onClick={() => {
                    setShouldRedirect(true);
                    setRedirectUrl('/createwizard/new-survey/poll');
                  }}
                  className="sm-home__cards sm-home__poll"
                >
                  <div className="sm-home__icon">
                    <IconPoll />
                  </div>
                  <Container className="sm-home__title" mb={3}>
                    <Typography variant="cardTitle">Create poll</Typography>
                  </Container>
                  <Container className="sm-home__subtitle">Write a survey to share with meeting attendees</Container>
                </Card>
              </If>
              <If condition={showCreateSurveyCard}>
                <Card
                  data-testid="Home__SurveyCard"
                  onClick={() => {
                    setShouldRedirect(true);
                    setRedirectUrl('/createwizard/new-survey/survey');
                  }}
                  className="sm-home__cards sm-home__survey"
                >
                  <div className="sm-home__icon">
                    <IconSurvey />
                  </div>
                  <Container className="sm-home__title" mb={3}>
                    <Typography variant="cardTitle">Create survey</Typography>
                  </Container>
                  <Container className="sm-home__subtitle">
                    <Typography variant="body">Write a survey to share with meeting attendees</Typography>
                  </Container>
                </Card>
              </If>
              <If condition={showStartFromTemplateCard}>
                <Card
                  data-testid="Home__TemplateCard"
                  onClick={() => {
                    setShouldRedirect(true);
                    setRedirectUrl('/createwizard/templates');
                  }}
                  className="sm-home__cards sm-home__template"
                >
                  <div className="sm-home__icon">
                    <IconTemplate />
                  </div>
                  <Container className="sm-home__title" mb={3}>
                    <Typography variant="cardTitle">Start from template</Typography>
                  </Container>
                  <Container className="sm-home__subtitle">
                    <Typography variant="body">Start from a expertly written poll or survey template</Typography>
                  </Container>
                </Card>
              </If>
            </Container>
          </Col>
        </Row>
      </Grid>
    </Container>
  );
};

export default Home;
